import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useHistoryOfChanges = (objectType, objectId, config, args = { verbose: 1 }) => {
  const slug = Angie.functions.slug(objectType);
  return useQuery({
    ...config,
    queryKey: ["history-of-changes", slug, objectId, args],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/history/${slug}/${objectId}?${encodeData(args)}`,
        signal,
      }),
  });
};
